(function() {
    'use strict';

    function isMobile(bodyWrapper) {
        if (navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i)) {
            bodyWrapper.classList.add('is-mobile');
        }
    }

    function isiOS(bodyWrapper) {
        if (navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)/i)) {
            bodyWrapper.classList.add('is-ios');
        }
    }

    function isIE(bodyWrapper) {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            bodyWrapper.classList.add('is-ie');
        }
    }

    function init() {
        var bodyWrapper = document.querySelector('body');

        isMobile(bodyWrapper);
        isiOS(bodyWrapper);
        isIE(bodyWrapper);
    }

    init();
})();
